import { Ring2 } from 'ldrs/react';
import { type ReactElement } from 'react';
import 'ldrs/react/Ring2.css';
import { type SpinnerProps } from './types';

export const Spinner = ({
  size = 40,
  stroke = 5,
  strokeLength = 0.25,
  bgOpacity = 0.1,
  speed = 0.8,
  color = 'var(--color-teal-600)',
}: SpinnerProps): ReactElement => (
  <Ring2
    size={size}
    stroke={stroke}
    strokeLength={strokeLength}
    bgOpacity={bgOpacity}
    speed={speed}
    color={color}
  />
);
